import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { useModalPreview } from "./Modal";

export const ViewOrderDetailsLine = () => {
  const { previewMutation } = usePaywallCheckoutContext();
  const modalPreview = useModalPreview();

  const showModal = () => {
    if (previewMutation?.data) {
      void modalPreview.show({ preview: previewMutation?.data });
    }
  };

  return (
    <Button
      variant="link"
      small
      className="!p-0 text-left"
      type="button"
      onClick={showModal}
      disabled={previewMutation.isLoading}
    >
      <Typography.LabelXs
        color={classNames("underline", {
          "text-secondary": !previewMutation.isLoading,
          "text-lightest": previewMutation.isLoading,
        })}
      >
        <span className="cursor-pointer">{t("view_order_details")}</span>
      </Typography.LabelXs>
    </Button>
  );
};
